var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AIBaseLayout',[_c('div',{staticClass:"wrapper",class:{ 'is-ios': _vm.isIOS, 'is-app': _vm.isAppEnvironment }},[_c('AIFeedComponent',{attrs:{"feed-page":_vm.AIFeedPageEnum.AIForyou}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }